export function is404GraphqlResponse(errors: unknown): boolean {
	return (
		Array.isArray(errors) &&
		errors.every(
			(err: unknown) =>
				err != null &&
				typeof err === 'object' &&
				'extensions' in err &&
				typeof err.extensions === 'object' &&
				err.extensions != null &&
				'statusCode' in err.extensions &&
				err?.extensions?.statusCode === 404,
		)
	);
}
